import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getHeapMapData } from '../../services/UsersApi';
import SubtopicBox from './SubtopicBox';
import { set } from 'lodash';
import './KCMasteryHeatmap.css'; // Assuming you have a CSS file for styling

const KCMasteryHeatmap = () => {
	const { userId } = useSelector((state) => state.userDetails);
	const [masteryData, setMasteryData] = useState([]);
	const [lowestMasterySubtopics, setLowestMasterySubtopics] = useState({
		READING_WRITING: [],
		MATHS: [],
	});
	const [highestMasterySubtopics, setHighestMasterySubtopics] = useState({
		READING_WRITING: [],
		MATHS: [],
	});
	const [showWeakest, setShowWeakest] = useState(true);

	useEffect(() => {
		const fetchHeatmapData = async () => {
			try {
				let res = await getHeapMapData(userId);
				//res = res.data;
				console.log('Response from getHeapMapData:', res.data);
				setMasteryData(res.data.mastery);
				setLowestMasterySubtopics(res.data.lowestMasterySubtopics);
				setHighestMasterySubtopics(res.data.highestMasterySubtopics);
				//console.log('Response from getHeapMapData:', JSON.stringify(masteryData));
			} catch (error) {
				console.log('Error fetching heatmap data:', error);
			}
		};
		fetchHeatmapData();
	}, []);

	useEffect(() => {
		console.log('Updated masteryData:', masteryData);
		console.log('Lowest mastery subtopics:', lowestMasterySubtopics);
		console.log('Highest mastery subtopics:', highestMasterySubtopics);
	}, [masteryData]);

	//console.log('Mastery data:', masteryData);

	const handleCardClick = () => {
		setShowWeakest((prev) => !prev);
	};

	return (
		<div className="weakest-section-container">
			<div className="grid-and-legend">
				{
					<div className="legend">
						<div>
							<div
								className="legend-box"
								style={{ backgroundColor: '#ff3300' }}
							></div>
							<span>0-30</span>
						</div>
						<div>
							<div
								className="legend-box"
								style={{ backgroundColor: '#e65c00' }}
							></div>
							<span>30-60</span>
						</div>

						<div>
							<div
								className="legend-box"
								style={{ backgroundColor: '#00cc99' }}
							></div>
							<span>60-90</span>
						</div>

						<div>
							<div
								className="legend-box"
								style={{ backgroundColor: '#00ff66' }}
							></div>
							<span>90-100</span>
						</div>
					</div>
				}

				<div className="mastery-grid">
					{masteryData?.map((entry, index) => (
						<div
							key={index}
							className="grid-box"
							style={{ backgroundColor: entry?.color || '#333' }}
							data-label={entry?.subtopicName || 'No subtopic name'}
						></div>
					))}
				</div>
			</div>

			<div className="section-content-kc-heatmap">
				<div className="header-row">
					<h3 className={showWeakest ? 'weakest-text' : 'strongest-text'}>
						{showWeakest ? 'Weakest Section' : 'Strongest Section'}
					</h3>
					<div className="toggle-button" onClick={handleCardClick}>
						Flip to view{' '}
						<span className={showWeakest ? 'strongest' : 'weakest'}>
							{showWeakest ? 'Strongest Section' : 'Weakest Section'}
						</span>
						<span className="icon">📊</span>
					</div>
				</div>

				<div className="subject-columns" onClick={handleCardClick}>
					<div className={`flip-card-inner ${showWeakest ? '' : 'flipped'}`}>
						<div className="flip-card-front">
							<div className="subject">
								<h4>Reading &amp; Writing</h4>
								{lowestMasterySubtopics?.READING_WRITING?.map((s) => (
									<SubtopicBox
										key={s.subtopicId}
										name={s.subtopicName}
										streak={s.streak}
										lastStudied={s.lastStudied}
										mastery={s.mastery}
										color={s.color}
									/>
								))}
							</div>
							<div className="subject">
								<h4>Maths</h4>
								{lowestMasterySubtopics?.MATHS?.map((s) => (
									<SubtopicBox
										key={s.subtopicId}
										name={s.subtopicName}
										streak={s.streak}
										lastStudied={s.lastStudied}
										mastery={s.mastery}
										color={s.color}
									/>
								))}
							</div>
						</div>

						<div className="flip-card-back">
							<div className="subject">
								<h4>Reading &amp; Writing</h4>
								{highestMasterySubtopics?.READING_WRITING?.map((s) => (
									<SubtopicBox
										key={s.subtopicId}
										name={s.subtopicName}
										streak={s.streak}
										lastStudied={s.lastStudied}
										mastery={s.mastery}
										color={s.color}
									/>
								))}
							</div>
							<div className="subject">
								<h4>Maths</h4>
								{highestMasterySubtopics?.MATHS?.map((s) => (
									<SubtopicBox
										key={s.subtopicId}
										name={s.subtopicName}
										streak={s.streak}
										lastStudied={s.lastStudied}
										mastery={s.mastery}
										color={s.color}
									/>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KCMasteryHeatmap;
